import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import SEO, { faqItems } from '../components/SEO';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';

const faqIcons = [<FiHeart />, <FiFlag />, <FiSearch />, <FiShare2 />, <FiLink />, <FiUser />, <FiMessageCircle />, <FiUsers />];

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-[#F4FBF8] text-[#17231F]">
      <SEO page="faq" />
      <Header />

      <main id="main-content">
        <section className="relative overflow-hidden bg-[#E9F6F0]">
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1554224154-26032ffc0d07?auto=format&fit=crop&q=80&w=1800"
              alt="Finance support workspace"
              className="h-full w-full object-cover opacity-15"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#E9F6F0] via-[#E9F6F0]/90 to-[#E9F6F0]/75" />
          </div>
          <div className="absolute inset-x-0 bottom-0 h-[3px] bg-gradient-to-r from-[#D97706] via-[#14B8A6] to-[#166534]" />
          <div className="relative mx-auto grid max-w-7xl gap-8 px-4 py-16 sm:px-6 lg:grid-cols-[0.35fr_0.65fr] lg:px-8 lg:py-24">
            <div>
              <div className="inline-flex w-fit items-center gap-2 rounded-full border border-emerald-900/10 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-[#0D6D65] shadow-lg shadow-emerald-950/5">
                FAQS
              </div>
            </div>
            <div>
              <div className="mb-6 h-1.5 w-20 rounded-full bg-[#D97706]" />
              <h1 className="max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-[#0B2F2A] sm:text-5xl">
                Frequently asked questions
              </h1>
            </div>
          </div>
        </section>

        <section className="bg-[#F4FBF8] px-4 py-20 text-[#17231F] sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.28fr_0.72fr]">
            <aside className="hidden lg:block">
              <div className="sticky top-28 border-l-4 border-[#D97706] pl-5">
                <p className="text-sm font-semibold text-[#0B2F2A]">Support topics</p>
                <p className="mt-3 text-sm leading-7 text-[#2D4A43]">
                  Answers about subscription management, billing questions, customer account access, and cancellation requests.
                </p>
              </div>
            </aside>
            <div>
              {faqItems.map((item, index) => (
                <FAQItem key={item.question} title={item.question} icon={faqIcons[index]}>
                  {item.answer}
                </FAQItem>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
